import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { TimeStream } from '../../utils'
import { WKVisible } from '../../components/wk'
import playImg from '../../images/schedule/play.png'
import pauseImg from '../../images/schedule/pause.png'
import likeImg from '../../images/schedule/like.png'
import likeActiveImg from '../../images/schedule/like-active.png'
import commentImg from '../../images/schedule/comment.png'
import hotImg from '../../images/schedule/hot.png'


class ScheduleItem extends React.Component {
    onClickImage (image, images) {
        if (window.wxReady) {
            window.wx.previewImage({
                current: image,
                urls: images,
            })
        } else {
            window.open(image)
        }
    }
    handleImgLoad (e, imagesCount) {
        if (imagesCount !== 1) {
            return
        }
        const rect = e.target.getBoundingClientRect()
        if (rect.height === rect.width && rect.width == 250) {
            e.target.style.width = e.target.style.height = '165px'
        }
    }
    render() {
        const { account, signinInfo, images } = this.props
        const audioDuration = this.props.audioDuration || signinInfo.audio_length
        const playPercent = this.props.audioCurrentTime / audioDuration * 100
        // 是否是本条语音被激活
        const isSelectedAudio = this.props.selectedAudioIndex === this.props.index
        return (
            <div className="schedule-signin-item wk-border-line-after wk-position-rlt">
                <div className="wrap">
                    <div className="avatar-wrap">
                        <img src={account.avatar_url} alt="" />
                    </div>
                    <div className="detail-wrap">
                        <div className="name text-ellipsis">{account.nickname}</div>
                        <div className="time">{TimeStream(signinInfo.create_timestamp)}</div>
                        <pre className="text">
                            {signinInfo.content}
                        </pre>
                        {/* 图片区 */}
                        <div className={`images image-count-${images.length}`}>
                            {
                                images.map((item, i) => (
                                    <img 
                                        src={item}
                                        className='image'
                                        key={i}
                                        onClick={e => this.onClickImage(item, images)}
                                        onLoad={e => this.handleImgLoad(e, images.length)}
                                    />
                                ))
                                // images.map((item, i) => (
                                //     <div 
                                //         className="image"
                                //         key={i} 
                                //         style={{backgroundImage: `url(${item})`}}
                                //         onClick={e => this.onClickImage(item, images)}
                                //     >
                                //     </div>
                                // ))
                            }
                        </div>
                        {
                            signinInfo.audio_url && (
                                <div className="audio-wrap" onClick={e => this.props.onClickAudio()}>
                                    <div className="icon">
                                        <img src={(this.props.audioStatus === 'playing' && isSelectedAudio) ? pauseImg : playImg} />
                                    </div>
                                    <WKVisible className="text" show={this.props.audioStatus === 'stop' || !isSelectedAudio}>
                                        <div>点击播放语音</div>
                                    </WKVisible>
                                    <WKVisible className='progress-wrap' show={this.props.audioStatus !== 'stop' && isSelectedAudio}>
                                        <div className="progress">
                                            <div 
                                                className="real-progress" 
                                                style={{width: `${playPercent <= 100 ? playPercent : 100}%`}}
                                            >
                                            </div>
                                        </div>
                                    </WKVisible>
                                    <div className="time">{audioDuration}''</div>
                                </div>
                            )
                        }
                        {/* 赞和评论操作区 */}
                        <div className="opera">
                            <div 
                                onClick={e => this.props.onClickDelSignin(signinInfo.id, this.props.index)} 
                                className="del"
                            >
                                {(this.props.myAccount.id === this.props.account.id || this.props.role.is_manager) ? '删除' : ''}
                            </div>
                            <div className="comment-like">
                                <div className="comment" onClick={e => this.props.onClickComment('')}>
                                    <img src={commentImg} alt="" />
                                    评论
                            </div>
                                <div className="like" onClick={e => this.props.onClickLike()}>
                                    {
                                        !this.props.isLike ? <img src={likeImg} /> : <img src={likeActiveImg} />
                                    }
                                    {this.props.likes.length > 0 ? this.props.likes.length : ''}
                                </div>
                            </div>
                        </div>
                        <WKVisible show={this.props.likes.length > 0 || this.props.comments.length > 0} className='margin-b-20'>
                            <div className="comment-like-wrap">
                                <div className="tip"></div>
                                {/* 赞列表区 */}
                                <WKVisible tag={null} create={this.props.likes.length > 0}>
                                    <div className={`like-wrap ${this.props.comments.length > 0 ? '' : 'no-comment'}`}>
                                        <img src={likeImg} alt="" />
                                        {
                                            this.props.likes.map((item, i) => (
                                                <span key={item.account.id}>{item.account.nickname}
                                                    <span>{i >= this.props.likes.length - 1 ? '' : '，'}</span>
                                                </span>
                                            ))
                                        }
                                    </div>
                                </WKVisible>
                                {/* 评论列表区 */}
                                <WKVisible create={this.props.comments.length > 0} tag={null}>
                                    <div className={`comment-wrap ${this.props.likes.length > 0 ? 'margin-top' : ''}`}>
                                        {
                                            this.props.comments.map((item, i) => (
                                                <div 
                                                    className="comment-item" 
                                                    key={item.id} 
                                                    onClick={e => this.props.onClickComment(item.id, i)}
                                                >
                                                    <span className="name-wrap">
                                                        <WKVisible create={!item.quote} tag={null}>
                                                            <span className='name'>
                                                                {item.account.nickname}：
                                                            </span>
                                                        </WKVisible>
                                                        <WKVisible create={item.quote} tag={null}>
                                                            <span>
                                                                <span className='name'>{item.account.nickname}</span>
                                                                <span className='reply-text'>回复</span>
                                                                <span className='name'>{item.quote && item.quote.nickname}：</span>
                                                            </span>
                                                        </WKVisible>
                                                    </span>
                                                    <span className="comment">{item.content}</span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </WKVisible>
                            </div>
                        </WKVisible>
                        
                    </div>
                </div>
                <WKVisible create={this.props.isHot} className='hot'>
                    <img src={hotImg} />
                </WKVisible>
            </div>
        )
    }
}

export default connect(state => ({
    myAccount: state.account
}))(ScheduleItem)


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleSigninItem.js